import { onReady } from "../../utils/events/onReady";
import { addEvent } from "../../utils/events/events";
import gsap from "gsap";
import { onClickOutside } from "../../utils/events/onClickOutside";
import { Dropdown } from "/src/components/dropdown/dropdown";

export class Header {
    /**
     * Internal placeholder for DOM-objects
     *
     * @type {object}
     * @ignore
     */
    dom = {
        container: undefined
    };

    /**
     *
     * @param {Element} domReference - The element to work from
     */
    constructor(domReference) {
        this.dom.container = domReference;
        onReady(() => this.init());
    }

    changeNavigation(theme) {
        const header = document.querySelector("header");
        if (scrollY >= 1) {
            header.classList.add(`is-scrolled-${theme}`);
        } else {
            header.classList.remove(`is-scrolled-${theme}`);
        }
    }

    openNavigationMobile(e) {
        const searchDesktop =
            this.dom.container.querySelector(".header__search");
        searchDesktop.style.display = "none";

        let tl = gsap.timeline();
        const menuButton = e.target;
        const ariaLabelValue = menuButton.getAttribute("aria-label");
        const navigationMobile = document.querySelector(
            ".header__left--navigation--mobile"
        );
        const links1 = document.querySelectorAll(".level-1-link");
        const links2 = document.querySelectorAll(".level-2-link");
        const links3 = document.querySelectorAll(".level-3-link");
        const breadCrumbMobile = navigationMobile.querySelectorAll(
            ".breadcrumb__container"
        );
        if (ariaLabelValue === "Open") {
            menuButton.setAttribute("aria-label", "Close");
            menuButton.setAttribute("aria-expanded", true);
            navigationMobile.classList.add("is-visible");
            const formInput = document.querySelector(".search__form--mobile input");
            addEvent(menuButton, "keydown", e => {

                if (e.key === "Tab" && menuButton.getAttribute("aria-label") === "Close") {
                    e.preventDefault();
                    formInput.focus();
                }
            });
            addEvent(formInput, "keydown", e => {

                if (e.key === "Tab" && e.shiftKey && menuButton.getAttribute("aria-label") === "Close") {
                    e.preventDefault();
                    menuButton.focus();
                }
            });
            links1.forEach(link => {
                link.setAttribute("aria-hidden", false);
                link.setAttribute("tabindex", 0);
            });
            document.querySelector("body").classList.add("no-scroll");
            tl.from(
                ".header__left--navigation-item .header__left--navigation-link--mobile",
                { duration: 0.5, opacity: 0, translateX: "50", stagger: 0.2 },
                "-=.1"
            );
        } else {
            document
                .querySelectorAll(".header__left--navigation-link--mobile")
                .forEach(link => {
                    link.setAttribute("aria-hidden", true);
                });
            menuButton.setAttribute("aria-label", "Open");
            menuButton.setAttribute("aria-expanded", false);
            const menuContainers = document.querySelectorAll(
                ".header__menu-container--mobile"
            );

            breadCrumbMobile.forEach(breadCrumb => {
                breadCrumb.setAttribute("tabindex", -1);
            });
            links1.forEach(link => {
                link.setAttribute("aria-hidden", true);
                link.setAttribute("tabindex", -1);
            });
            links2.forEach(link => {
                link.setAttribute("aria-hidden", true);
                link.setAttribute("tabindex", -1);
            });
            links3.forEach(link => {
                link.setAttribute("aria-hidden", true);
                link.setAttribute("tabindex", -1);
            });




            const subMenuContainers = document.querySelectorAll(
                ".header__menu-container--sublink-container"
            );
            menuContainers.forEach(container => {
                container.setAttribute("aria-expanded", false);
            });
            subMenuContainers.forEach(container => {
                container.setAttribute("aria-expanded", false);
            });
            navigationMobile.classList.remove("is-visible");
            document.querySelector("body").classList.remove("no-scroll");

        }
    }

    openNavLinkMobile(e) {
        const link = e.target;
        const links2 = document.querySelectorAll(".level-2-link");
        links2.forEach(link => {
            link.setAttribute("aria-hidden", false);
            link.setAttribute("tabindex", 0);
        });
        link.setAttribute("aria-expanded", true);
        link.blur();
        document
            .querySelectorAll(".header__left--navigation-link--mobile")
            .forEach(linkItem => {
                linkItem.blur();
                linkItem.setAttribute("aria-hidden", true);
                linkItem.setAttribute("tabindex", -1);
                const noLink = linkItem.classList.contains("no-link");


            });
        const backBtn = link.parentNode.querySelector(".breadcrumb__container.level-1");
        backBtn.setAttribute("tabindex", 0);
        backBtn.setAttribute("aria-expanded", true);
        backBtn.focus();
        const parent = link.parentNode;
        parent.children[1].setAttribute("aria-expanded", true);

    }

    menuBackMobile(e) {
        const parent = e.target.parentNode.parentNode;
        const linksContainer = parent.parentNode.parentNode;
        const focusableElements = parent.querySelectorAll("a, button");
        e.target.setAttribute("aria-expanded", false);
        focusableElements.forEach(element => {
            element.setAttribute("tabindex", -1);
        });
        linksContainer.querySelectorAll(".level-1-link").forEach(link => {
            link.setAttribute("aria-hidden", false);
            link.setAttribute("aria-expanded", false);
            link.setAttribute("tabindex", 0);
        });
        const backBtn = document.querySelector(".breadcrumb__container.level-1");
        backBtn.setAttribute("tabindex", -1);
        document.querySelector(".level-1-link")?.focus();
        parent.setAttribute("aria-expanded", false);

    }

    menuBackMobileLevel2(e) {
        const parent = e.target.parentNode;
        const linksContainer = parent.parentNode;
        linksContainer.querySelectorAll(".level-2-link").forEach(link => {
            link.setAttribute("aria-hidden", false);
            link.setAttribute("aria-expanded", false);
            link.setAttribute("tabindex", 0);
        });
        const backBtn1 = parent.parentNode.parentNode.parentNode.querySelector(".breadcrumb__container.level-1");
        backBtn1.setAttribute("tabindex", 0);
        backBtn1.focus();
        const backBtn2 = e.target;
        backBtn2.setAttribute("tabindex", -1);
        backBtn2.setAttribute("aria-expanded", false);
        // parent.setAttribute("aria-expanded", false);
        // parent.classList.add("is-closed");

    }

    openNavLinkMobileLevelTwo(e) {
        if (e.target.classList.contains("no-link")) {
            return;
        }
        e.target.setAttribute("aria-expanded", true);
        const links3 = document.querySelectorAll(".level-3-link");
        links3.forEach(link => {
            link.setAttribute("aria-hidden", false);
            link.setAttribute("tabindex", 0);
        });
        document
            .querySelectorAll(".level-2-link")
            .forEach(linkItem => {
                linkItem.blur();
                linkItem.setAttribute("aria-hidden", true);
                linkItem.setAttribute("tabindex", -1);
                const noLink = linkItem.classList.contains("no-link");
                if (!noLink) {
                    const parent = linkItem.parentNode;
                    // parent.children[1].classList.add("hidden");
                }

            });
        const parent = e.target.parentNode;
        const backBtn1 = document.querySelector(".breadcrumb__container.level-1");
        backBtn1.setAttribute("tabindex", -1);
        const backBtn2 = document.querySelector(".breadcrumb__container.level-2");
        backBtn2.setAttribute("tabindex", 0);
        backBtn2.setAttribute("aria-expanded", true);
        backBtn2.focus();
        // parent.children[1].setAttribute("aria-expanded", true);
    }

    handleSubmit(e) {
        e.preventDefault();
        const input = e.target.querySelector("input");
        const queryParam = input.value;
        const searchValue = queryParam;
        const searchValueEncoded = encodeURIComponent(searchValue);
        const searchValueDecoded = decodeURIComponent(searchValueEncoded);
        const searchValueTrimmed = searchValueDecoded.trim();
        const searchValueLength = searchValueTrimmed.length;
        console.log(searchValueLength);

        if (searchValueLength < 2) {
            console.log("Search value is too short");
            return;
        }

        e.target.submit();
    }
    async openSearchDesktop(e) {
        e.preventDefault();
        e.stopPropagation()
        const searchDesktop =
            this.dom.container.querySelector(".header__search");



        //If open then close instead
        if (searchDesktop.classList.contains("animate__fadeIn")) {

            this.closeSearchDesktop();
            return;
        }

        //Close dropdown if open, so they don't overlap
        const dropDownElement = this.dom.container.querySelector(".dropdown__container");
        dropDownElement.children[0].setAttribute("aria-expanded", false);
        dropDownElement.children[1].setAttribute("aria-hidden", true);

        searchDesktop.style.display = "inline-block";
        searchDesktop.classList.remove("animate__fadeOut")
        searchDesktop.classList.add("animate__animated", "animate__fadeIn");

        document.querySelector("#queryParam").focus()
    }

    closeSearchDesktop(e) {
        const searchDesktop = document.querySelector(".header__search");

        searchDesktop.addEventListener('animationend', () => {
            if (searchDesktop.classList.contains("animate__fadeOut")) {
                searchDesktop.classList.remove("animate__fadeOut")
                searchDesktop.style = "display:none"
            }
        }, { once: true });
        searchDesktop.style.setProperty('--animate-duration', '0.3s');
        searchDesktop.classList.remove("animate__fadeIn")
        searchDesktop.classList.add("animate__fadeOut")
    }

    init() {
        console.log("Header initialized");

        const skipLink = document.querySelector(".skip-link");
        skipLink.addEventListener("click", e => {
            const target = e.target.getAttribute("href");
            document.querySelector(target).focus();
        });
        skipLink.addEventListener("keyup", e => {
            if (e.keyCode === 13) {
                const target = e.target.getAttribute("href");
                document.querySelector(target).focus();
            }
        });
        addEvent(document, "keydown", e => {
            if (e.key === "Escape") {
                this.closeSearchDesktop(e);
            }
        });

        onClickOutside(this.dom.container, () => this.closeSearchDesktop());
        window.onorientationchange = () => {
            document.querySelector("body").classList.remove("no-scroll");
            if (document.querySelector(".menu-open")) {
                document
                    .querySelector(".menu-open")
                    .classList.remove("menu-open");
            } else if (
                document.querySelector(
                    ".header__left--navigation--mobile.is-visible"
                )
            ) {
                document
                    .querySelector(
                        ".header__left--navigation--mobile.is-visible"
                    )
                    .classList.remove("is-visible");
                document
                    .querySelector(".button.button__header--mobile")
                    .setAttribute("aria-label", "Open");
                document
                    .querySelector(".button.button__header--mobile")
                    .setAttribute("aria-expanded", false);
            } else {
                return;
            }
        };
        // Change bg-color/theme based on page-type
        addEvent(document, "scroll", () => this.changeNavigation());
        const navigationMobile = document.querySelector(
            ".button.button__header--mobile"
        );
        const breadCrumbMobile = document.querySelectorAll(
            ".breadcrumb__container.level-1"
        );
        const breadCrumbMobileLevel2 = document.querySelectorAll(
            ".breadcrumb__container.level-2"
        );
        breadCrumbMobile.forEach(breadCrumb => {
            addEvent(breadCrumb, "click", e => this.menuBackMobile(e));
        });
        breadCrumbMobileLevel2.forEach(breadCrumb => {
            addEvent(breadCrumb, "click", e => this.menuBackMobileLevel2(e));
        });

        addEvent(navigationMobile, "click", e => this.openNavigationMobile(e));

        const navLinkMobile = document.querySelectorAll(
            ".header__left--navigation-link--mobile"
        );
        navLinkMobile.forEach(link => {
            addEvent(link, "click", e => this.openNavLinkMobile(e));
        });

        const levelTwoNavLink = document.querySelectorAll(
            ".level-2-link"
        );
        levelTwoNavLink.forEach(link => {
            addEvent(link, "click", e => this.openNavLinkMobileLevelTwo(e));
        });
        // Hide navbar on scrolldrown
        const articleLayout = document.querySelector(".article-layout");
        if (articleLayout) {
            addEvent(document, "scroll", () =>
                this.changeNavigation("articleLayout")
            );
        } else {
            addEvent(document, "scroll", () => this.changeNavigation("layout"));
        }

        let lastScrollTop;
        const navbar = document.querySelector("header");
        const dropdown = document.querySelector(
            ".header__right--dropdown.button"
        );
        const listDropdown = document.querySelector(".dropdown__list--link");

        //add animation only on mobile
        window.addEventListener("scroll", function () {
            if (window.innerWidth < 992) {
                if (!document.querySelector(".menu-open")) {
                    let scrollTop =
                        window.pageYOffset ||
                        document.documentElement.scrollTop;
                    if (scrollTop > lastScrollTop && scrollTop > 25) {
                        navbar.classList.add(
                            "animate__animated",
                            "animate__slideOutUp"
                        );
                        navbar.setAttribute("aria-hidden", true);
                        dropdown.setAttribute("aria-expanded", false);
                        // listDropdown.setAttribute("aria-hidden", true);
                    } else if (scrollTop < lastScrollTop) {
                        navbar.classList.remove(
                            "animate__animated",
                            "animate__slideOutUp"
                        );
                        navbar.classList.add(
                            "animate__animated",
                            "animate__slideInDown"
                        );
                        navbar.setAttribute("aria-hidden", false);
                    }
                    lastScrollTop = scrollTop;
                }
            }
        });
        const searchDesktop = this.dom.container.querySelector(
            ".button__header--desktop-search"
        );
        const searchDesktopForm = this.dom.container.querySelector(".header__search__container--form");
        const searchMobileForm = this.dom.container.querySelector(".search__form--mobile");

        addEvent(searchDesktop, "click", e => this.openSearchDesktop(e));
        const closeButton = this.dom.container.querySelector(
            ".header__close-search"
        );
        addEvent(closeButton, "click", e => this.closeSearchDesktop(e));

        addEvent(searchDesktopForm, "submit", e => this.handleSubmit(e));
        addEvent(searchMobileForm, "submit", e => this.handleSubmit(e));

    }
}
